const isAuthenticated = state => state.auth.user.isAuth;
const getUserName = state => state.auth.user.username;
const getUserEmail = state => state.auth.user.email;
const getToken = state => state.auth.token.accessToken;
const getUserId = state => state.auth.user.id;
const getError = state => state.auth.error;
const isLoading = state => state.auth.loading;

const authSelectors = {
    isAuthenticated,
    getUserName,
    getUserEmail,
    getToken,
    getUserId,
    getError,
    isLoading,
};

export default authSelectors;
